import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Icon } from "@arcteryx/components-icons";
import { P, ScreenSize } from "@arcteryx/components-typography";

const SimpleFooter = () => {
  const { t } = useTranslation();

  return (
    <FooterContainer>
      <FooterTop>
        <FooterTopColumn>
          <FooterTopLink href="/help" aria-label={t("Customer Support Center")}>
            <P size="s">{t("Customer Support Center")}</P>
          </FooterTopLink>
          <FooterTopLink href="/contact" aria-label={t("Contact Us")}>
            <P size="s">{t("Contact Us")}</P>
          </FooterTopLink>
        </FooterTopColumn>
        <FooterTopColumn>
          <FooterTopLink href="/shipping" aria-label={t("Shipping & Delivery")}>
            <P size="s">{t("Shipping & Delivery")}</P>
          </FooterTopLink>
          <FooterTopLink href="/returns" aria-label={t("Refunds & Returns")}>
            <P size="s">{t("Refunds & Returns")}</P>
          </FooterTopLink>
        </FooterTopColumn>
        <FooterTopColumn>
          <P size="s">{t("Available payment methods")}</P>
          <IconsWrapper>
            <Icon type="apple-pay-logo" width="50" height="25" title={t("footer.applePay")} />
            <Icon type="paypal-logo" width="50" height="30" title={t("footer.paypal")} />
            <Icon type="visa-logo" width="50" height="30" title={t("footer.visa")} />
            <Icon type="google-pay-logo" width="50" height="30" title={t("footer.googlePay")} />
            <Icon type="amex-logo" width="50" height="30" title={t("footer.amex")} />
            <Icon type="klarna-logo" width="50" height="30" title={t("footer.klarna")} />
          </IconsWrapper>
        </FooterTopColumn>
        <FooterTopColumn>
          <LocaleWrapper>
            <Icon type="flag-ca" width="20px" height="17px" />
            <P>CA/EN</P>
          </LocaleWrapper>
        </FooterTopColumn>
      </FooterTop>
      <FooterBottom>
        <div>
          <FooterBottomLink href="/help/cookies" aria-label={t("Cookie Policy")}>
            <P size="s">{t("Cookie Policy")}</P>
          </FooterBottomLink>
          <span>|</span>
          <FooterBottomLink href="/help/privacy" aria-label={t("Privacy Policy")}>
            <P size="s">{t("Privacy Policy")}</P>
          </FooterBottomLink>
          <span>|</span>
          <FooterBottomLink href="/help/terms-and-conditions" aria-label={t("Terms &amp; Conditions")}>
            <P size="s">{t("Terms & Conditions")}</P>
          </FooterBottomLink>
          <span>|</span>
          <FooterBottomLink href="/help/terms-of-use" aria-label={t("Terms of Use")}>
            <P size="s">{t("Terms of Use")}</P>
          </FooterBottomLink>
          <span>|</span>
          <FooterBottomLink href="/help/accessibility" aria-label={t("Accessibility")}>
            <P size="s">{t("Accessibility")}</P>
          </FooterBottomLink>
          <span>|</span>
          <FooterBottomLink href="/help/privacy#do-not-sell-my-personal-information" aria-label={t("Do Not Sell My Personal Information")}>
            <P size="s">{t("Do Not Sell My Personal Information")}</P>
          </FooterBottomLink>
          <span>|</span>
          <FooterBottomLink href="/procline-boot" aria-label={t("Recall Info")}>
            <P size="s">{t("Recall Info")}</P>
          </FooterBottomLink>
        </div>
        <div>
          <P size="s">{t("Arc'teryx - an Amer Sports Brand")}</P>
        </div>
      </FooterBottom>
    </FooterContainer>
  );
};

SimpleFooter.propTypes = {
  footerLinks: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ),
};

const FooterContainer = styled.footer`
background-color: #fff;
padding: 2rem;
`;

const FooterTop = styled.div`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  padding: 1rem;

  @media only screen and (max-width: ${ScreenSize.md}px) {
    flex-wrap: wrap;

    text-align: center;
    > div {
      &:last-child {
        width:100%;
      }

      &:nth-last-child(2) {
        width:100%;
      }
    }
  }
`;

const FooterTopColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterTopLink = styled.a`
  text-align: center;
  margin-bottom: 0.5rem;
  text-decoration: none;
`;

const FooterBottom = styled.div`

  line-height:1rem;

  > div:first-child {
    display: flex;
    justify-content: center;
    padding: 1rem 1rem 0 1rem;
    font-size: 13px;
  }
  > div:last-child {
    text-align: center;
    > p {
      max-width: 100%;
    }
  }

    @media only screen and (max-width: ${ScreenSize.md}px) {

      > div:first-child, 
      div:last-child {
        padding: 1rem 1rem 0 0;
        flex-wrap: wrap;
        justify-content: flex-start;
          text-align:  left;
      }
  }
`;

const FooterBottomLink = styled.a`
  margin-right: 0.25rem;
  margin-left: 0.25rem;
  margin-bottom: 0.5rem;
  text-decoration: none;
  text-align: center;
`;

const IconsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;
  > svg {
    margin-right: 0.5rem;
  }
`;
const LocaleWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;

  > svg {
    margin-right:0.5rem;
  }
`;

export default SimpleFooter;
